import { Checkmark } from '@carbon/icons-react';
import { defineMessages, useIntl } from 'react-intl';
import cx from 'classnames';

import InfoCard from 'Components/Common/InfoCard/InfoCard';
import styles from './CategoryInfoCard.module.scss';

const CategoryInfoCard = ({
    onlyItems = false,
    isClosable = false,
    id,
    className,
}: {
    onlyItems?: boolean;
    isClosable?: boolean;
    id?: string;
    className?: string;
}) => {
    const intl = useIntl();

    return (
        <InfoCard
            id={id}
            className={cx(styles.card, className)}
            isHorizontal
            isClosable={isClosable}
            onlyItems={onlyItems}
            title={intl.formatMessage(messages.title)}
            description={intl.formatMessage(messages.description)}
            items={[
                {
                    icon: <Checkmark size={20} />,
                    title: intl.formatMessage(messages.contactTitle),
                    description: intl.formatMessage(messages.contactDescription),
                },
                {
                    icon: <Checkmark size={20} />,
                    title: intl.formatMessage(messages.cooperationTitle),
                    description: intl.formatMessage(messages.cooperationDescription),
                },
                {
                    icon: <Checkmark size={20} />,
                    title: intl.formatMessage(messages.relationshipTitle),
                    description: intl.formatMessage(messages.relationshipDescription),
                },
            ]}
        />
    );
};

const messages = defineMessages({
    title: {
        id: 'src.Screens.Dashboard.InitialSetup.steps.CategoriesStep.CategoryInfoCard.title',
        defaultMessage: 'Kontakty parafialne możesz uzupełnić później',
    },
    description: {
        id: 'src.Screens.Dashboard.InitialSetup.steps.CategoriesStep.CategoryInfoCard.description',
        defaultMessage: 'Ten krok jest nieobowiązkowy, ale dobrze opisane role i funkcje pomagają parafianom szybciej znaleźć właściwy kontakt.',
    },
    contactTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.steps.CategoriesStep.CategoryInfoCard.contactTitle',
        defaultMessage: 'Jasny kontakt',
    },
    contactDescription: {
        id: 'src.Screens.Dashboard.InitialSetup.steps.CategoriesStep.CategoryInfoCard.contactDescription',
        defaultMessage: 'Parafianie wiedzą, do kogo zgłosić się w konkretnej sprawie.',
    },
    cooperationTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.steps.CategoriesStep.CategoryInfoCard.cooperationTitle',
        defaultMessage: 'Prostsza współpraca',
    },
    cooperationDescription: {
        id: 'src.Screens.Dashboard.InitialSetup.steps.CategoriesStep.CategoryInfoCard.cooperationDescription',
        defaultMessage: 'Łatwiej organizować zgłoszenia, dyżury i codzienny kontakt z parafianami.',
    },
    relationshipTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.steps.CategoriesStep.CategoryInfoCard.relationshipTitle',
        defaultMessage: 'Lepsze relacje',
    },
    relationshipDescription: {
        id: 'src.Screens.Dashboard.InitialSetup.steps.CategoriesStep.CategoryInfoCard.relationshipDescription',
        defaultMessage: 'Porządek w komunikacji pomaga budować bliższą relację z parafianami.',
    },
});

export default CategoryInfoCard;
